import { ActionContext } from "vuex";
import { ContentState } from "./content_module";
import { watch } from "vue";

export class CountdownState {
    timer: number | undefined;
}

const state = new CountdownState();

const mutations = {

};

type CountdownActionContext = ActionContext<CountdownState, ContentState>;
const actions = {

};

const gettters = {

};

export default {
    namespace: true,
    state,
    mutations,
    actions,
    gettters,
}